export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.18.0',
};
//# sourceMappingURL=buildEnv.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/@datadog/browser-rum-core/esm/boot/buildEnv.js
// module id = ../../../../@datadog/browser-rum-core/esm/boot/buildEnv.js
// module chunks = 5